import styled from 'styled-components';

export const TitleInstitutional = styled.p`
  font-family: 'Lato';
  font-size: 24px;
  color: #161d1f;
  font-weight: 700;
`;

export const ParagraphText = styled.p`
  margin-top: 12px;
  font-family: 'Lato';
  font-size: 14px;
  color: #161d1f;
  font-weight: 400;
  text-align: justify;
`;

export const ContainerTab = styled.div`
  margin-top: 16px;
`;

export const ContainerOptions = styled.div`
  display: flex;
  @media (max-width: 600px) {
    scroll-behavior: smooth;
    overflow-x: hidden;
  }
`;

export const CardButtonInstitutional = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center; /* Align items vertically centered */
  box-shadow: 4px 2px 4px #eaeef1;
  transition: background 0.3s ease; /* Smooth transition for hover/focus */

  &:hover {
    background: #d5e5f0;
  }

  &:focus {
    background: #a8cbe2;
    outline: none; /* Remove default focus outline if customized */
  }

  /* Responsive adjustments */
  @media (max-width: 600px) {
    /* Stack items vertically on small screens */
    align-items: flex-start; /* Align to the start for better text visibility */
    gap: 10px; /* Add space between text and icons when stacked */
  }
`;

export const ContainerCardsInstitutional = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two equal columns by default */
  gap: 20px;
  margin-top: 16px;
  /* padding: 20px; */

  /* Ensure items flow into the left column first */
  & > * {
    grid-column: auto;
  }

  /* For odd items, prioritize filling the left column */
  @media (min-width: 641px) {
    & > *:nth-child(odd) {
      grid-column: 1;
    }
    & > *:nth-child(even) {
      grid-column: 2;
    }
  }

  /* Switch to single column for screens 360px or smaller */
  @media (max-width: 640px) {
    grid-template-columns: 1fr; /* Single column */
    & > * {
      grid-column: 1; /* All items in the single column */
    }
  }
`;

export const TextCard = styled.p`
  font-size: 14px;
  font-family: 'Lato';
  color: #161d1f;
  margin: 0; /* Remove default margin */
  word-break: break-word; /* Allow words to break and wrap */
  max-width: 80%; /* Ensure text doesn't overflow the card */
  line-height: 1.5; /* Improve readability with line spacing */

  @media (max-width: 600px) {
    max-width: 100%; /* Full width on small screens */
    font-size: 13px; /* Slightly smaller text on small screens */
  }
`;

export const CardsIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & > div {
    min-width: 30px; /* Minimum width to ensure icons are visible */
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 18px;
      height: 18px;
      object-fit: contain; /* Ensure the image scales properly */
    }
    &:nth-child(2) {
      margin-top: 2px;
    }
  }

  @media (max-width: 600px) {
    & > div {
      min-width: 25px; /* Slightly smaller but still visible */
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
`;

export const ArticuleBlock = styled.article`
  position: fixed;
  height: 100%;
  width: 45vw;
  top: 0;
  right: 0;
  z-index: 1000;
  background-color: #ffffff;
  justify-content: flex-end;
  @media (max-width: 640px) {
    overflow-y: scroll;
    width: 100%;
  }
`;
export const SideBarModal = styled.div`
  background-color: 'rgb(40 48 68 / 60%)';
  position: fixed;
  left: 0%;
  right: 0%;
  top: 0;
  bottom: 0;
  z-index: 99;
  height: '100%';
`;
